module.exports = __webpack_public_path__ + "media/images/arrow-trend-down-0c7d376a7ece9633317ba49363e1298b.svg";